export const splitSubtitle = (value) => {
    const text = value.trim().replace(/\s+/g, " ");
    if (!text) return ["", ""];

    const words = text.split(" ");
    if (words.length === 1) {
        const middle = Math.ceil(text.length / 2);
        return [text.slice(0, middle), text.slice(middle)];
    }

    let splitAt = 1;
    let smallestDifference = Infinity;
    for (let index = 1; index < words.length; index += 1) {
        const first = words.slice(0, index).join(" ");
        const second = words.slice(index).join(" ");
        const startsWithShortWord = /^(i|u|na|za|od|do|sa|se|je|su|o|a)$/i.test(words[index]);
        const difference = Math.abs(first.length - second.length) + (startsWithShortWord ? 6 : 0);
        if (difference < smallestDifference) {
            smallestDifference = difference;
            splitAt = index;
        }
    }

    return [words.slice(0, splitAt).join(" "), words.slice(splitAt).join(" ")];
};
